<div class="sidebar-wrapper">
  <app-sidebar-header (backButtonClicked)="goToPreviousPage()" [showBackButton]="currentPage() > 1">
    <div smallTitle>{{ rfi()?.id ? 'Edit' : 'Add' }} RFI</div>
    <div mainTitle>Request For Information</div>
  </app-sidebar-header>
  <div class="main-content overflow-scroll flex flex-col">
    <form class="flex-1 flex flex-col" name="ngForm" #form="ngForm" role="form">
      @if (currentPage() === CREATE_RFI_PAGE.FIRST_PAGE) {
        <app-floating-input
          name="rfi_number"
          [disabled]="!RFINumberEditable()"
          [(ngModel)]="model().rfi_number"
          label="RFI Number"
          placeholder="RFI Number"
          [iconClass]="RFINumberEditable() ? 'icon-text-revert' : 'icon-text-edit'"
          (iconClick)="onRFINumberIconClick()"
          (inputBlurred)="RFINumberChanged($event)"
        ></app-floating-input>
        <app-input-calendar
          name="due_date"
          [date]="model().due_date"
          (dateChanged)="updateModel({ due_date: $event })"
          [required]="true"
          [minStartDate]="minStartDate()"
          placeholder="Due Date"
        ></app-input-calendar>
        <app-floating-input
          name="subject"
          [ngModel]="model().subject"
          (ngModelChange)="updateModel({ subject: $event })"
          required
          label="Subject"
          placeholder="Subject"
        ></app-floating-input>

        <app-dropdown
          name="rfi_manager_id"
          [options]="teamMembers()"
          [ngModel]="model().rfi_manager_id"
          (ngModelChange)="updateModel({ rfi_manager_id: $event })"
          optionValue="id"
          required
          label="RFI Manager"
          placeholder="RFI Manager"
        >
          <ng-template #optionContent #selectedContent let-option>
            <div class="flex flex-col">
              <div class="text-navy-900 font-semibold">{{ option?.first_name + ' ' + option?.last_name }}</div>
              <div class="text-navy-900 font-normal">{{ option?.company_name }}</div>
            </div>
          </ng-template>
        </app-dropdown>

        <app-dropdown
          name="rfi_responsible_id"
          [options]="allUsers()"
          [ngModel]="model().rfi_responsible_id"
          (ngModelChange)="updateModel({ rfi_responsible_id: $event })"
          optionValue="id"
          required
          label="Responsibility"
          placeholder="Responsibility"
        >
          <ng-template #optionContent #selectedContent let-option>
            <div class="font-normal">
              <span class="font-semibold">{{ option.name }}</span
              >, {{ option.company_name }}
            </div>
          </ng-template>
        </app-dropdown>

        <div class="two-input-row">
          <app-dropdown
            name="originator_user_id"
            [options]="allUsers()"
            [ngModel]="model().originator_user_id"
            (ngModelChange)="updateModel({ originator_user_id: $event })"
            optionValue="id"
            class="flex-1"
            label="Originator"
            placeholder="Originator"
          >
            <ng-template #optionContent #selectedContent let-option>
              <div class="font-normal">
                <span class="font-semibold">{{ option.name }}</span
                >, {{ option.company_name }}
              </div>
            </ng-template>
          </app-dropdown>
          <app-floating-input
            name="originator_rfi_id"
            [ngModel]="model().originator_rfi_id"
            (ngModelChange)="updateModel({ originator_rfi_id: $event })"
            class="flex-1"
            label="Originator RFI ID"
            placeholder="Originator RFI ID"
          ></app-floating-input>
        </div>

        <div class="flex gap-4">
          <app-dropdown
            name="cost_impact"
            [ngModel]="costImpact()"
            (ngModelChange)="costImpactChanged($event)"
            class="flex-1"
            label="Cost Impact"
            placeholder="Cost Impact"
            [options]="costImpactOptions()"
          ></app-dropdown>
          <app-floating-input
            name="estimated_amount"
            [ngModel]="model().estimated_cost"
            (ngModelChange)="updateModel({ estimated_cost: $event })"
            class="flex-1"
            label="Estimated Amount"
            placeholder="Estimated Amount"
            [disabled]="!costImpact()"
            type="money"
          ></app-floating-input>
        </div>

        <div class="flex gap-4">
          <app-dropdown
            name="schedule_impact"
            [ngModel]="scheduleImpact()"
            (ngModelChange)="scheduleImpactChanged($event)"
            class="flex-1"
            label="Schedule Impact"
            placeholder="Schedule Impact"
            [options]="scheduleImpactOptions()"
          ></app-dropdown>
          <app-dropdown
            name="estimated_schedule"
            [ngModel]="model().estimated_schedule"
            (ngModelChange)="updateModel({ estimated_schedule: $event })"
            [options]="dayOptions()"
            optionLabel="label"
            optionValue="value"
            class="flex-1"
            label="Estimated Time"
            placeholder="Estimated Time"
            [disabled]="!scheduleImpact()"
            disabledStyle="background"
          ></app-dropdown>
        </div>
      } @else if (currentPage() === CREATE_RFI_PAGE.SECOND_PAGE) {
        <div class="">
          <app-input-upload
            [allowMultipleFiles]="true"
            [files]="files()"
            (filesChanged)="onFilesChange($event)"
            (removeFile)="removeFile($event)"
            label="Attachments"
            placeholder="Click to upload files or drag & drop"
          >
          </app-input-upload>
        </div>

        <div class="flex-1 flex">
          <app-floating-textarea
            name="question"
            [ngModel]="model().question"
            (ngModelChange)="updateModel({ question: $event })"
            required
            label="Question"
            placeholder="Type your question here..."
          ></app-floating-textarea>
        </div>

        <app-tag-dropdown
          name="participants"
          [ngModel]="selectedParticipants()"
          (ngModelChange)="onParticipantsChanged($event)"
          [availableTags]="availableParticipants()"
          label="Participants"
          class="h-52"
        ></app-tag-dropdown>

        <div class="flex gap-4">
          <app-floating-input
            name="drawing_id"
            [ngModel]="model().drawing_id"
            (ngModelChange)="updateModel({ drawing_id: $event })"
            [required]="false"
            class="flex-1"
            label="Drawing ID"
            placeholder="Drawing ID"
          ></app-floating-input>
          <app-floating-input
            name="section_reference"
            [ngModel]="model().section_reference"
            (ngModelChange)="updateModel({ section_reference: $event })"
            [required]="false"
            class="flex-1"
            label="Section Reference"
            placeholder="Section Reference"
          ></app-floating-input>
        </div>
      }
    </form>
  </div>
  <div
    class="buttons flex gap-4"
    [ngClass]="{
      'justify-between': currentPage() === 2 && !rfi()?.status,
      'justify-end': currentPage() !== 2 || !!rfi()?.status,
    }"
  >
    @if (currentPage() === 2 && !rfi()?.status) {
      <app-simple-button (click)="saveDraft()" buttonStyle="color_secondary_border">Save Draft</app-simple-button>
    }

    @if (currentPage() === 1) {
      <app-simple-button (click)="goToNextPage()">Next</app-simple-button>
    } @else {
      <app-simple-button (click)="submitForm()" buttonStyle="color_accent_filled">Submit</app-simple-button>
    }
  </div>
</div>
